import { colorsPalettes } from "@similarweb/styles";
import type { FC } from "react";

import styled from "styled-components";

interface IRelevancyScoreProps {
    bullets: number;
    maxBullets: number;
}

const ScoreContainer = styled.div`
    display: flex;
    justify-content: space-around;
`;
const FullBullet = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background-color: ${colorsPalettes.midnight["200"]};
`;
const EmptyBullet = styled(FullBullet)`
    background-color: ${colorsPalettes.carbon["50"]};
`;

export const RelevancyScore: FC<IRelevancyScoreProps> = ({ bullets, maxBullets }) => {
    const fullBullets = Math.round(bullets);
    return (
        <ScoreContainer>
            {Array.from(Array(maxBullets)).map((value, i) => {
                return i < fullBullets ? <FullBullet /> : <EmptyBullet />;
            })}
        </ScoreContainer>
    );
};

RelevancyScore.displayName = "RelevancyScore";
